import React, {Fragment} from 'react';
import {Flex, List, Form, Edit, Submit, Card, Tag, Icon, NumberFormat, InlineNumberFormat, EditableTag} from 'components';
import {over, useNamedSelector, openPopup, useBuffer, useSelector} from 'helpers';
import {update, updateStatus} from 'store/activities';
import {units} from 'store';

export function TrackProgress({ activity, contextDate, position }) {
  const {dailyResult} = useNamedSelector('calendar.record', { id: activity.id, date: contextDate }) || {};
  const unit = useSelector(units.getById)(activity.unitId);
  const [control, {update}] = useBuffer({
    value: dailyResult || '',
    onChange({value, floatValue = 0}) {
      if (floatValue || value === '') {
        updateStatus({ id: activity.id, contextDate, dailyResult: floatValue });
      }
    }
  });

  const clear = () => updateStatus({id: activity.id, contextDate, dailyResult: 0});

  const spacer = Boolean(control.value) && (
    <NumberFormat displayType="text" value={control.value} thousandSeparator />
  );

  return (
    <Fragment>
      <Card.Progress now={dailyResult || 0} max={activity.numericalTarget} position={position}>
        <Flex className={['bigger', 'middle', 'justified']}>
          <EditableTag value={spacer} placeholder="+ result" clear={clear}>
            <NumberFormat {...control} onValueChange={update} thousandSeparator />
          </EditableTag>
          {activity.numericalTarget > 0 &&
            <InlineNumberFormat
              value={activity.numericalTarget}
              unit={unit?.name}
            />
          }
        </Flex>
      </Card.Progress>
    </Fragment>
  );
}
